import "./i18n-syncfusion"; // carregando translate portugues e espanhol do syncfusion
import "./i18n/index.jsx"; // carregando translate portugues e espanhol do sistema inteiro

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
